// extracted by mini-css-extract-plugin
export default {"container":"RightSidebar_container__3I2hw"};